"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createActionLayout = void 0;
const actionButton_1 = require("./actionButton");
const createActionLayout = (makeViews) => {
    const views = Array.isArray(makeViews) ? makeViews : [makeViews];
    const items = views.map(makeView => ({
        render: (props) => {
            const { key, kind, click, isLoading, disabled, hidden, state } = props;
            const view = typeof makeView === 'function' ? makeView(state) : makeView;
            if (view === undefined)
                return (0, actionButton_1.renderEmptyActionButton)(kind);
            const { targetOption, ...restView } = view;
            if (hidden(targetOption))
                return (0, actionButton_1.renderEmptyActionButton)(kind);
            return (0, actionButton_1.renderActionButton)({
                ...restView,
                key,
                kind,
                click: () => click(targetOption),
                isLoading: isLoading(targetOption),
                disabled: disabled(targetOption),
            });
        },
    }));
    return {
        items,
    };
};
exports.createActionLayout = createActionLayout;
//# sourceMappingURL=actionLayout.js.map